import { render, staticRenderFns } from "./children-route.vue?vue&type=template&id=bf8bb6d4&scoped=true&"
import script from "./children-route.vue?vue&type=script&lang=js&"
export * from "./children-route.vue?vue&type=script&lang=js&"
import style0 from "./children-route.vue?vue&type=style&index=0&id=bf8bb6d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8bb6d4",
  null
  
)

export default component.exports